// src/components/Conferences.js
import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../css/Conferences.css';

const Conferences = () => {
  const { t } = useTranslation();

  const conferences = t('conferences_list', { returnObjects: true });
  const invitedSeminarTalks = t('invited_seminar_talks_list', { returnObjects: true });
  const researchVisits = t('research_visits_list_current', { returnObjects: true });
  const renderListItem = (item) => {
    if (typeof item === 'string') {
      return item;
    }

    return [
      item.title || item.institution,
      item.dates || item.month_year,
      item.location,
      item.professors,
      item.year,
      item.note,
    ]
      .filter(Boolean)
      .join(', ');
  };

  return (
    <Container>
      <section id="conferences" className="conference-section conference-section-contributed">
        <h2>{t('nav_conferences')}</h2>
        <ol>
          {Array.isArray(conferences) && conferences.map((conference, index) => (
            <li key={index}>
              {renderListItem(conference)}
            </li>
          ))}
        </ol>
      </section>

      <section id="invited_seminar_talks" className="conference-section conference-section-invited">
        <h2>{t('nav_invited_seminar_talks')}</h2>
        <ol>
          {Array.isArray(invitedSeminarTalks) && invitedSeminarTalks.map((talk, index) => (
            <li key={index}>{renderListItem(talk)}</li>
          ))}
        </ol>
      </section>

      <section id="research_visits" className="conference-section conference-section-visits">
        <h2>{t('nav_research_visits')}</h2>
        <ol>
          {Array.isArray(researchVisits) && researchVisits.map((visit, index) => (
            <li key={index}>
              {renderListItem(visit)}
            </li>
          ))}
        </ol>
      </section>
    </Container>
  );
}

export default Conferences;
